import { BorderTheme } from '@kite-js/theme-types';

const border: BorderTheme = {
    NONE: 'none',
    S: '1px',
    M: '2px',
};

export default border;
